import { Button } from 'primereact/button';
import { InputText } from 'primereact/inputtext';
import { Sidebar } from 'primereact/sidebar';
import { useEffect, useState } from 'react';
import FormInput from '../../../../components/Form/FormInput';
import ImageForm from '../../common/image/ImageForm';
import { CONSTANT } from '../../../../utils/constants';
import { SelectButton } from 'primereact/selectbutton';
import { Form } from 'react-router-dom';

function CircumstanceManager({
  isOpen,
  onClose,
  circumstance,
  loading,
  onUpdate,
  onCreate,
  isProject
}) {
  const [title, setTitle] = useState('');
  const [description, setDescription] = useState('');
  const [images, setImages] = useState([]);
  const [size, setSize] = useState(CONSTANT.shared.imageSizes[0].value);
  const [horizontalAlignment, setHorizontalAlignment] = useState(
    CONSTANT.shared.imageHorizontalAlignments[1].value
  );
  const [verticalAlignment, setVerticalAlignment] = useState(
    CONSTANT.shared.imageVerticalAlignments[1].value
  );

  useEffect(() => {
    if (circumstance) {
      setTitle(circumstance.title || '');
      setImages(circumstance.images);
      setDescription(circumstance.description || '');
      setSize(circumstance.image_size);
      setHorizontalAlignment(circumstance.horizontal_image_alignment);
      setVerticalAlignment(circumstance.vertical_image_alignment);
    } else {
      setTitle('');
      setImages([]);
      setDescription('');
      setSize(CONSTANT.shared.imageSizes[0].value);
      setHorizontalAlignment(CONSTANT.shared.imageHorizontalAlignments[1].value);
      setVerticalAlignment(CONSTANT.shared.imageVerticalAlignments[1].value);
    }
  }, [circumstance, isOpen]);

  const handleValidate = () => {
    const circumstancePayload = {
      title,
      images: images.map((image) => image.id),
      description,
      image_size: size,
      horizontal_image_alignment: horizontalAlignment,
      vertical_image_alignment: verticalAlignment
    };
    circumstance ? onUpdate(circumstancePayload) : onCreate(circumstancePayload);
  };

  const formIsValid = () => {
    return images.length > 0;
  };

  const footerButtons = (
    <div className="manage-footer">
      <Button
        key={'validate'}
        label={`Valider la ${circumstance ? 'modification' : 'création'}`}
        className="w-full"
        onClick={handleValidate}
        severity="success"
        disabled={!formIsValid()}
        loading={loading}
      />
    </div>
  );

  return (
    <Sidebar
      style={{ width: 700 }}
      visible={isOpen}
      position="right"
      onHide={() => onClose(false)}
      header={
        <h3 className="text-slate-800 text-2xl font-medium">{`${circumstance ? 'Modifier' : 'Ajouter'} ${isProject ? 'une image' : 'une actualité'}`}</h3>
      }>
      <div className="sidebar-content-container">
        <div className="form-wrapper !pb-60">
          <FormInput label={`Titre`} required={!isProject} isValid={title.length}>
            <InputText
              id="title"
              value={title}
              maxLength={300}
              placeholder="Veuillez saisir le titre"
              onChange={(e) => setTitle(e.target.value)}
            />
          </FormInput>
          <FormInput label={'Description'}>
            <InputText
              id="description"
              value={description}
              maxLength={300}
              placeholder="Veuillez saisir la description"
              onChange={(e) => setDescription(e.target.value)}
            />
          </FormInput>
          {isProject && (
            <FormInput label={'Position et alignement'} className="flex flex-col gap-y-3">
              <SelectButton
                value={size}
                onChange={(e) => setSize(e.value)}
                optionLabel="label"
                options={CONSTANT.shared.imageSizes}
              />
              <SelectButton
                value={horizontalAlignment}
                onChange={(e) => setHorizontalAlignment(e.value)}
                optionLabel="label"
                options={CONSTANT.shared.imageHorizontalAlignments}
              />
              <SelectButton
                value={verticalAlignment}
                onChange={(e) => setVerticalAlignment(e.value)}
                optionLabel="label"
                options={CONSTANT.shared.imageVerticalAlignments}
              />
            </FormInput>
          )}

          {images.length > 0 && (
            <div className="flex flex-wrap gap-5">
              {images.map((image, index) => (
                <>
                  <ImageForm
                    key={image.id ?? index}
                    image={image}
                    setImage={(img) =>
                      setImages((prevImages) =>
                        prevImages.map((prevImage, i) => (i === index ? img : prevImage))
                      )
                    }
                    deleteImage={() =>
                      setImages((prevImages) => prevImages.filter((_, i) => i !== index))
                    }
                    label={`Image ${index + 1}`}
                    choosePosition={isProject}
                  />
                </>
              ))}
            </div>
          )}
          {(!isProject || (isProject && images.length === 0)) && (
            <ImageForm
              key="add-new-image"
              image={undefined}
              setImage={(img) => setImages((prevImages) => [...prevImages, img])}
              label="Ajouter une nouvelle image"
              required={images.length === 0}
            />
          )}
        </div>
        {footerButtons}
      </div>
    </Sidebar>
  );
}

export default CircumstanceManager;
